import { TFunction } from 'i18next'
import React, { FunctionComponent, PropsWithChildren } from 'react'
import { Trans } from 'react-i18next'

import TransComponents from './TransComponents'

interface I18nTransProps extends PropsWithChildren {
  t: TFunction
  i18nKey: string
  values?: Record<string, unknown>
  components?:
    | readonly React.ReactElement[]
    | { readonly [tagName: string]: React.ReactElement }
  defaults?: string
}

export const WriskTrans: FunctionComponent<I18nTransProps> = ({
  components,
  ...props
}) => <Trans {...props} components={{ ...TransComponents, ...components }} />
